import { NavigableModal } from '$components'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { EditClientDetailsForm, EditClientDetailsSchema, Input } from '$features/clients/forms/edit-client-details/index'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { clientShowOptions, clientShowQueryKey, clientUpdateMutation } from '$api-client/@tanstack/react-query.gen'
import { ToastHelper } from '$components'
import { ToastType } from '$components'
import { ClientsFilterParam } from '$features/clients/enums/filter-params'

export function EditClientDetailsModal() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const queryClient = useQueryClient()

  const { data } = useQuery({
    ...clientShowOptions({
      path: {
        id: Number(id),
      },
      query: {
        include_deleted: true,
        [ClientsFilterParam.IncludeUnapproved]: searchParams.get(ClientsFilterParam.IncludeUnapproved) === '1',
      },
    }),
  })

  const { mutate: updateClient, isPending: isUpdatingClient } = useMutation({
    ...clientUpdateMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: clientShowQueryKey({
          path: {
            id: Number(id),
          },
        }),
      })

      ToastHelper.updateSuccess(ToastType.Client)
      handleClose()
    },
    onError: () => ToastHelper.updateError(ToastType.Client),
  })

  const handleClose = () => navigate(-1)

  const handleSubmit = async (values: EditClientDetailsSchema) => {
    updateClient({
      path: {
        client: Number(id),
      },
      // @ts-expect-error - TODO: fix this
      body: values,
    })
  }

  const client = data?.data

  if (!client) {
    return null
  }

  return (
    <EditClientDetailsForm
      onSubmit={handleSubmit}
      onCancel={handleClose}
      isLoading={isUpdatingClient}
      defaultValues={{
        [Input.Email]: client.email,
        [Input.Phone]: client.phone,
        [Input.InternalNotes]: client.internal_notes ?? undefined,
      }}
    >
      <NavigableModal onClose={handleClose}>
        <NavigableModal.Header>
          <NavigableModal.Heading>
            Edit Client Details
          </NavigableModal.Heading>
        </NavigableModal.Header>

        <NavigableModal.Content>
          <EditClientDetailsForm.Content />
        </NavigableModal.Content>

        <NavigableModal.Footer>
          <EditClientDetailsForm.Controls />
        </NavigableModal.Footer>
      </NavigableModal>
    </EditClientDetailsForm>
  )
}
